type CountryIso = 'BY' | 'KZ' | 'KG' | 'RU' | string

/**
 * PDF «карточка компании» зависит от страны сайта.
 */
export default function getCompanyCardHref(staticPath: string, countryIso: CountryIso): string {
  const map: Record<string, string> = {
    BY: `${staticPath}_v1/ydoc/documents/info/by/Ydoc_BY_бланк.pdf`,
    KZ: `${staticPath}_v1/ydoc/documents/info/kz/Ydoc_KZ_бланк.pdf`,
    KG: `${staticPath}_v1/ydoc/documents/info/kg/Ydoc_KG_бланк.pdf`,
  }

  return map[countryIso] || `${staticPath}_v1/pd/documents/pdf/ООО_МедРокет.pdf`
}
